import { Image } from '@tribeplatform/gql-client/types'
import { SquareLogo } from '@tribeplatform/react-components/Logo'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import { WorkspacesList } from './WorkspacesList.js'

export function Workspaces() {
  const { data: network } = useNetwork()
  /**
   * The background is always dark so we need to use the light logo.
   */
  const logo = network?.images?.darkMobileLogo ?? network?.favicon
  return (
    <div className="w-20 h-full flex items-center justify-center">
      <Dropdown placement="bottom-end">
        <Dropdown.ButtonMinimal>
          <SquareLogo size="2x" image={logo as Image} />
        </Dropdown.ButtonMinimal>
        <Dropdown.Items maxWidth="md" className="w-[320px] sm:w-[360px]">
          <WorkspacesList />
        </Dropdown.Items>
      </Dropdown>
    </div>
  )
}
